import { render } from "./EditorNew.vue?vue&type=template&id=4e6abc75"
import script from "./EditorNew.vue?vue&type=script&lang=js"
export * from "./EditorNew.vue?vue&type=script&lang=js"

import "./EditorNew.vue?vue&type=style&index=0&id=4e6abc75&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__